import { render, staticRenderFns } from "./PartidaGrid.vue?vue&type=template&id=5aeb2e81"
import script from "./PartidaGrid.vue?vue&type=script&lang=js"
export * from "./PartidaGrid.vue?vue&type=script&lang=js"
import style0 from "./PartidaGrid.vue?vue&type=style&index=0&id=5aeb2e81&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports